export const middlewares = {};

middlewares.color = a => {
	return `rgb(${a.map(v => v | 0).join(",")})`;
};

export default function middleware (a, b, r) {
	let _a = [...a], len = _a.length, gmw = typeof r === "string" && middlewares[r];
	return function (t) {
		for ( let i = 0; i < len; i++ ) {
			_a[i] = a[i] + (b[i] - a[i]) * t;
		}
		return gmw ? gmw(_a) : _a;
	}
};
